import iptu from "../Assets/IconesSistemas/iptu.png";
import itbi from "../Assets/IconesSistemas/itbi.png";
import issqn from "../Assets/IconesSistemas/issqn.png";
import consultaNfse from "../Assets/IconesSistemas/consulta-nfse.png";
import notasFiscais from "../Assets/IconesSistemas/notas-fiscais.png";
import solicitacaoCompra from "../Assets/IconesSistemas/solicitacao-compra.png";
import processoLicitatorio from "../Assets/IconesSistemas/processo-licitatorio.png";
import licitacoesContratos from "../Assets/IconesSistemas/licitacoes-contratos.png";
import cadastroProdutos from "../Assets/IconesSistemas/cadastro-produtos.png";
import siafic from "../Assets/IconesSistemas/siafic.png";
import portalTransparencia from "../Assets/IconesSistemas/portal-transparencia.png";
import portalServidor from "../Assets/IconesSistemas/portal-servidor.png";
import assinaturaDigital from "../Assets/IconesSistemas/assinatura-digital.png";
import protocolo from "../Assets/IconesSistemas/protocolo.png";

/**
 * =============================================================================
 *  LOGOS DOS SISTEMAS PELO FRONT — PREVIEW
 * =============================================================================
 *
 *  As logos do banco vinham de estilos diferentes. Estas são do Flaticon, todas
 *  no estilo "Lineal Color" do Freepik — o mesmo traço das logos que já estavam
 *  boas e FICAM como estão (não estão neste mapa): Arrecadação, Cobrança de
 *  Água, Relatórios de Gestão e Cadastro Único.
 *
 *  ⚠️ O CIDADE DIGITAL FICA DE FORA DE PROPÓSITO: é o app do cidadão, e a marca
 *  é da PREFEITURA (TRESPADIGITAL, meuMax, Trindade na Palma da Mão — ver
 *  resolverSistemaDisplay). Ele sempre mostra a logo que o município escolheu.
 *
 *  ⚠️ Só vale para o Login Único. O header dos outros sistemas usa a logo do
 *  banco. Aprovado o visual, o caminho é cadastrar estes PNGs como logo de cada
 *  sistema (Editar sistema) e apagar este arquivo.
 *
 *  Licença Flaticon gratuita: exige atribuição ao autor (Freepik), a menos que a
 *  Sinsoft tenha plano Premium. Ids originais ao lado de cada linha.
 *
 *  Para voltar às logos do banco: USAR_LOGOS_DO_FRONT = false.
 * =============================================================================
 */
// Desligado em 2026-10-20: as 14 logos deste mapa foram cadastradas no banco
// (PUT /sistema), então o banco já devolve as mesmas imagens.
export const USAR_LOGOS_DO_FRONT = false;

/** Trecho do título (sem acento, CAIXA ALTA) -> imagem. Busca por substring. */
const MAPA_LOGOS: Array<[string, string]> = [
    ["IPTU", iptu], // flaticon 2484013 — casinha com chaminé e árvore
    ["ITBI", itbi], // 4969084 — entrega das chaves
    ["ISSQN", issqn], // 353343
    ["NFS-E", consultaNfse], // 7253124
    ["NOTAS FISCAIS", notasFiscais], // 2522929

    ["SOLICITACAO DE COMPRA", solicitacaoCompra], // 167535
    ["PROCESSO LICITATORIO", processoLicitatorio], // 8293524
    ["LICITACOES", licitacoesContratos], // 3375199 — pasta da documentação
    ["CADASTRO DE PRODUTOS", cadastroProdutos], // 595645 — caixa com etiqueta

    ["SIAFIC", siafic], // 12692388 — calculadora + relatório + moeda
    ["PORTAL DA TRANSPARENCIA", portalTransparencia], // 1838419 — prédio da prefeitura

    ["PORTAL DO SERVIDOR", portalServidor], // 998427
    // título CRU: em São José o Cidade Digital é EXIBIDO como "Protocolo
    // Eletrônico", mas o título do banco continua "Cidade Digital" — não casa aqui
    ["PROTOCOLO", protocolo], // 10275924 — documento carimbado
    ["ASSINATURA DIGITAL", assinaturaDigital], // 4696830
];

function normalizar(texto: any): string {
    return String(texto ?? "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toUpperCase()
        .trim();
}

/**
 * Logo do front para o sistema, ou null quando ele não está no mapa — aí a
 * tela continua com a logo do banco (ou as iniciais, se não houver).
 * Recebe o sistema CRU: o mapa compara com o título do banco.
 */
export function logoDoFront(sistema: any): string | null {
    if (!USAR_LOGOS_DO_FRONT) return null;

    const titulo = normalizar(sistema?.titulo);
    const achado = MAPA_LOGOS.find(([trecho]) => titulo.includes(normalizar(trecho)));

    return achado ? achado[1] : null;
}
